/*This view represents what you see when you are looking for a book club to join.*/

import { useState } from 'react';
import { BookOpen, Search, Users } from 'lucide-react';
import JoinButton from '../components/joinButton';
import { isUserMember } from '../utils';
import { useNavigate } from "react-router-dom";

export default function FindClubsView(props){

  const [searchParams, setSearchParams] = useState({ name: "", genre: "" });
  const navigate = useNavigate();

  function updateNameACB(event){
    const value = event.target.value;
    console.log("entered name:", value);
    setSearchParams(prev => ({ ...prev, name: value }));
  }
  function updateGenreACB(event){ 
    const value = event.target.value;
    console.log("selected genre:", value);
    setSearchParams(prev => ({ ...prev, genre: value }));
  }
  function fetchClubsACB(event){
    event.preventDefault();
    console.log("searchParams i fetchClubsACB:", searchParams);
    props.fetchAllClubs(searchParams);

  }

  function navigateToClubPageCB(clubId){
         props.onNavigateToClub(clubId)
         navigate(`/myClubs/${clubId}`)
  }
 

    function renderClubsCB(club){
        console.log(club)
        const isMember = isUserMember(club, props.user.currentUser);

    return (
        <li key={club.id} 
            className={`bg-white rounded-xl shadow-md !border border-blue-100 overflow-hidden 
                hover:shadow-xl transition-shadow flex flex-col flex-none basis-full md:basis-[calc(50%-0.75rem)] lg:basis-[calc(33.333%-1rem)]
                ${isMember ? 'cursor-pointer' : ''}`}
            onClick={()=>{
                if (isMember) navigateToClubPageCB(club.id)
            }}
        >
            <div className="p-3 flex flex-col h-full">
                <div className="flex items-start justify-between mb-3">
                    <div className="flex-1">
                        <h3 className="text-blue-900 mb-1">{club.clubName}</h3>
                        <p className="text-blue-600">Genre: {club.genre}</p>
                    </div>
                    <div className="flex items-center gap-1 text-blue-700">
                        <Users className="w-4 h-4" />
                        <span>{club.members.length}</span>
                    </div>
                </div>
                {/* Show club's current book */}
                {club.currentBook && (
                    <div className="mb-4"> 
                        <p className="text-blue-700 mb-2">Currently Reading:</p>
                        <div> 
                            <img 
                                src={club.currentBook.bookImg}
                                alt={club.currentBook.title}
                                className="w-16 h-20 object-cover rounded"/>
                            <div> 
                                <p className="text-blue-900">{club.currentBook.title}</p>
                                <p className="text-blue-600">{club.currentBook.author}</p>
                            </div>
                        </div>
                    </div>
                )}
                {/* If no current book set */}
                {!club.currentBook && (
                    <div className="mb-4 p-4 bg-blue-50 rounded-lg flex items-center gap-2"> 
                        <BookOpen className="w-5 h-5 text-blue-500 -translate-y-1/3" />
                        <p className="text-blue-700">No current book</p>
                    </div>
                )}

                {/* Send join request */}
                <div className="mt-auto h-[38px]">
                    {isMember ? (
                         <div className="flex items-center justify-center h-full px-4 
                            bg-green-100 text-green-800 !border border-green-200 rounded-lg text-md font-medium cursor-default">
                            You are already a member
                        </div>

                    ) : (
                        <JoinButton 
                        clubId={club.id}
                        userId={props.user.currentUser} 
                        username={props.user.username} 
                        profileImg={props.user.userIMG}
                        pendingRequests={club.pendingRequests ?? []}
                        onSendJoinRequest={props.onSendJoinRequest}
                        onCancelJoinRequest={props.onCancelJoinRequest}
                        />
                    )}
                </div>
                
                     
            </div>
        </li>
    )
  }
    return <div className="min-h-screen bg-sky-50 overflow-x-hidden">
          <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 py-6 lg:px-8 py-8">
              {/* Find Clubs */}
              <div className="mb-4">
                <h1 className="text-blue-900 mb-2">Find Book Clubs</h1>
                <p className="text-blue-700">Discover and join reading communities</p>
              </div>
              {/* Search input box */}
              <div className="mb-5 relative">
                
                <form onSubmit={fetchClubsACB} className="flex flex-col sm:flex-row w-full max-w-[700px] gap-2">
                    <div className="relative flex flex-1">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-blue-400"/>
                        <input type="text" placeholder="Search by name" value={searchParams.name} onChange={updateNameACB} 
                            className="flex-[3] pl-10 pr-4 py-2 !border border-blue-200 border-r-0 !rounded-l-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset bg-white"/>
                        <select value={searchParams.genre} onChange={updateGenreACB} 
                            className="w-full sm:w-1/5 text-blue-700/85 bg-white !rounded-r-lg hover:bg-blue-50 !border border-blue-200 border-l-0 pl-2 pr-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset cursor-pointer">
                            <option value="">All Genres</option>
                            <option value="Fiction">Fiction</option>
                            <option value="Fantasy">Fantasy</option>
                            <option value="Science Fiction">Science Fiction</option>
                            <option value="Horror">Horror</option>
                            <option value="Mystery">Mystery/Thriller</option>
                            <option value="Romance">Romance</option>
                            <option value="Literary fiction">Literary Fiction</option>
                            <option value="Non-fiction">Non-Fiction</option>
                        </select>
                    </div>
                    <button type="submit"
                        className="w-full sm:w-auto px-4 py-1 bg-blue-500 text-white !rounded-lg hover:bg-blue-600 transition-colors">Search</button>
                </form>
              </div>

              {/* Render search results */}
                {props.searchResults && props.searchResults.length > 0  && (/*auto-rows-min*/
                    <ul className="flex flex-wrap gap-6 p-0 m-0 ">
                        {props.searchResults.map(renderClubsCB)}
                    </ul>
                )} 
              
                {/* No clubs found */}
                {(!props.searchResults || props.searchResults.length === 0) && (
                  <div className="flex flex-col items-center justify-center min-h-[50vh] bg-sky-50"> 
                      <BookOpen className="w-16 h-16 text-blue-300 mx-auto mb-4"/>
                      <p className="text-blue-600">No book clubs found matching your search</p>
                  </div>
                )}
            </div>
        </div>
  }